import {ENDPOINT_OBLIGATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const callGetObligationByGrantId = ({grantId}) => {
  return getObligationByGrantId(grantId);
};

const callGetAllObligationsByGrantId = ({grantId}) => {
  return getAllObligationsByGrantId(grantId);
};

const getObligationByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}grant/${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllObligationsByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}grantId/${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const callGetObligationBySubGrants = ({subGrants}) => {
  return Promise.all(
    subGrants.map((subGrant) => getAllObligationsByGrantId(subGrant.grantId))
  );
};

const getSubGrantTotalObligationAmountsByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}subGrantObligationAmounts/${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const callGetSubGrantTotalObligationAmountsForGrantIds = ({grantIds}) => {
  return Promise.all(
    grantIds.map((grantId) => getSubGrantTotalObligationAmountsByGrantId(grantId))
  );
};

const isReturnOfFundsRequestValid = ({entityId, entityType, rofAmount}) => {
  const endpoint = `${ENDPOINT_OBLIGATION}entityId/${entityId}/entityType/${entityType}/rofAmount/${rofAmount}`;
  return fetch(endpoint, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  callGetObligationByGrantId,
  getObligationByGrantId,
  callGetObligationBySubGrants,
  callGetAllObligationsByGrantId,
  getAllObligationsByGrantId,
  getSubGrantTotalObligationAmountsByGrantId,
  callGetSubGrantTotalObligationAmountsForGrantIds,
  isReturnOfFundsRequestValid,
};
